import { dataHooks } from '@wix/data-hooks'

export const sorryDataHooks = dataHooks<{
  title: {}
  image: {}
  subtitle: {}
  primaryButton: {}
  secondaryButton: {}
}>('customize-site-error-template')
